import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const FlightIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none">
        <path
          d="M0 50L50 0M0 0l50 50M25 0v50M0 25h50M0 12.5h50m-50 25h50M12.5 0v50m25-50v50M25 49.688c13.635 0 24.688-11.053 24.688-24.688S38.635.313 25 .313.313 11.366.313 25 11.366 49.688 25 49.688z"
          stroke="#ffffff"
          className={styles.white}
          strokeWidth="0.5"
        />
        <path
          d="M25 37.188c6.731 0 12.188-5.457 12.188-12.188S31.73 12.813 25 12.813 12.813 18.269 12.813 25 18.269 37.188 25 37.188z"
          stroke="#ffffff"
          className={styles.white}
          strokeWidth="0.5"
        />
        <path
          d="M25 30.938a5.937 5.937 0 100-11.875 5.937 5.937 0 000 11.875z"
          stroke="#ffffff"
          className={styles.white}
          strokeWidth="0.5"
        />
        <path
          clipRule="evenodd"
          d="M0 0h50v50H0z"
          fill="#ffffff"
          className={styles.white}
          fillRule="evenodd"
        />
        <path
          d="M12.153 34.136l1.544 7.155c.096.443.634.62.973.318l2.102-1.868c.326-.29.53-.691.572-1.124l.792-8.222m-8.677 1.478l-7.202-1.638a.554.554 0 01-.287-.913l1.949-2.144a1.68 1.68 0 011.098-.543l8.249-.703"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M36.31 20.089c.111-.087 1.124-.606 1.243-.673 1.103-.612 2.282-.173 3.084.85.889 1.133.938 2.61-.195 3.5l-2.645 1.849M17.661 6.529l1.654-2.031a2.25 2.25 0 013.157-.322l.459.373c.957.78 1.103 2.2.323 3.158l-.375.46"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinejoin="bevel"
          strokeWidth="1.5"
        />
        <path
          d="M28.592 9.645L4.354 3.38a1.9 1.9 0 00-1.39.177l-1.678.933a.676.676 0 00-.018 1.172l19.564 11.63"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M34.987 15.222l6.101 24.115a3.3 3.3 0 01-.313 2.403l-.308.552a1.102 1.102 0 01-1.91.029l-11.49-19.292"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M22.703 15.535L33.178 5.06s5.985-5.611 8.978-3.74-2.618 8.603-2.618 8.603L27.566 21.895l-8.23 7.482s-7.482 6.734-9.353 4.49c-1.87-2.246 3.741-8.231 3.741-8.231z"
          stroke="#000000"
          className={styles.defaultStrokeColor}
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M38.438 27.813c5.877 0 10.624 4.781 10.624 10.625 0 5.843-4.749 10.624-10.624 10.624S27.812 44.28 27.812 38.439s4.748-10.626 10.625-10.626z"
          fill="#ffffff"
          className={classnames(styles.white, styles.defaultStrokeColor)}
          fillRule="evenodd"
          stroke="#000000"
          strokeWidth="1.5"
        />
        <path
          clipRule="evenodd"
          d="M42.802 44.395v-2.22H37.39q.486-.612.625-1.422.14-.81-.065-1.797h2.784v-1.85h-3.04q-.589-2.521.468-3.123c1.057-.602 2.549-.314 3.52.473h.873v-2.068c-.627-.581-3.414-1.492-5.92-.238q-2.505 1.254-1.714 4.956h-.736v1.85h1.191q.283 1.388 0 2.292-.283.905-1.258 1.27v1.877z"
          fill="#E81C30"
          className={styles.accentColor}
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}
